export default function getApiUri(){
    //if (process.env.REACT_APP_NODE_ENV === 'development') {
    if (window.location.href.indexOf("rapidtoolz") > -1){
        return ''
    } else {
        return process.env.REACT_APP_SERVER_URI
    }
}